import FieldTags from "../../../generic/tags/tags"
import FieldConfig from "../../../proto/field-config"
import ItemModel from "../../../../model2/item/item-model"
import TableManager from "../../../../gd-modules/table/manager/table-manager"
import TaskListManager from "../../../../gd-modules/task-list/manager/manager"
import {LifecycleAction} from "../../../../gd/const/lifecycle"

export default class FieldTaskTags extends FieldTags {

    constructor(config:FieldConfig) {
        super(config)

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    tableCellOnValueChange = (item:ItemModel, value:any, manager:TableManager|TaskListManager) => {
        // @ts-ignore
        item.task[this.fieldId] = value
        item.task.save()

        item._updateLastUpdateTime() // otherwise it wont re-render
        manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])
    }
}
